import { TUser } from '@/features/users/schemas/users.schema.ts';
import { UserPlantsAccessManagementDialog } from '@/features/users/components/users-table/user-plant-access-management/user-plant-access-management.tsx';

export const UsersTableRowPlantAccessAction = ({ user }: { user: TUser }) => {
  return (
    <UserPlantsAccessManagementDialog user={user}>
      <button className="focus:bg-accent focus:text-accent-foreground relative flex w-full cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden transition-colors select-none hover:bg-gray-100 data-disabled:pointer-events-none data-disabled:opacity-50">
        <span>Plant Access Management</span>
      </button>
    </UserPlantsAccessManagementDialog>
  );
};
